import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class AppHttpService {
    constructor(private httpService: HttpClient) {

    }

    /* Only the Controller and Action location are needed.  The rest of the URL is configured when the application loads */
    get<T>(URL: string, userParams: any): Observable<T> {
        const i = this.createURL(URL);
        return this.httpService.get<T>(this.createURL(URL), { params: userParams });
    }
    
    getFile<T>(URL: string, body: any) {
        return this.httpService.post(this.createURL(URL), body, {responseType: 'blob'});
    }

    post<T>(URL: string, body: any): Observable<T> {
        const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json',
            })
          };
        return this.httpService.post<T>(this.createURL(URL), body, httpOptions);
    }

    postFile<T>(URL: string, body: any, params: HttpParams, headers: HttpHeaders): Observable<T> {
       
        return this.httpService.post<T>(this.createURL(URL), body, {params, headers});
    }

    createURL(URL: string): string {
        let tempURL = '';
        return tempURL = environment.apiURL  + this.sanitizeURL(URL);

    }

    sanitizeURL(URL: string): string {
        if (URL.startsWith('/'))  {
            URL = URL.substring(1, URL.length);
        }

        return URL;

    }
}
